module.exports = __webpack_public_path__ + "static/media/curMetodos.adf8334b.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/curMetodos.png
// module id = 799
// module chunks = 0